import {getRoundedValue} from "../api-mpms";
import {bignumber, BigNumber} from "mathjs";

export interface Unit {
  roundingIncrement: BigNumber
}

export abstract class UnitValue<U extends Unit> {

  value: BigNumber
  unit: U

  constructor(value: BigNumber | number, unit: U) {
    this.value = bignumber(value)
    this.unit = unit
  }

  protected roundedValue(): BigNumber {
    return getRoundedValue(this.value, this.unit)
  }
}
